import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import QuillFieldRenderer from '../../components/carousel review/QuillFieldRenderer';
import { FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../components/common/tooltip';
import InputField from '../../../components/common/input-field';

interface PlaceHolderFieldProps<T extends Record<string, string>> {
  value: T;
  onChange: (_value: T) => void;
  data: {
    label: string;
    value: keyof T;
  }[];
  name?: string;
}

export const PlaceHolderField = <T extends Record<string, string>>({
  value,
  onChange,
  data,
  name = 'Place Holder',
}: PlaceHolderFieldProps<T>) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>Place Holder</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <>
          {data.map((item, index) => {
            return (
              <>
                {name != 'quill' ? (
                  <FieldLabel
                    key={index}
                    label={
                      (
                        <CustomTooltip title="Text">
                          <span>{item.label} placeholder</span>
                        </CustomTooltip>
                      ) as React.ReactNode as string
                    }
                    className="mt-4"
                    el="div">
                    <InputField
                      value={value[item.value]}
                      onChange={text =>
                        onChange({ ...value, [item.value]: text })
                      }
                    />
                  </FieldLabel>
                ) : (
                  <QuillFieldRenderer
                    label={data[index].label as string}
                    value={value[item.value]}
                    onChange={text =>
                      onChange({ ...value, [item.value]: text })
                    }
                    id={index + 2}
                  />
                )}
              </>
            );
          })}
        </>
      )}
    </div>
  );
};
